import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {SenatorQualityGateService, SenatorService} from '../../../../../api/services';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {SenatorTrades} from '../../../../../api/models/senator-trades';
import {SenatorCompany} from '../../../../../api/models/senator-company';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ShowTradeByIdComponent} from '.././show-trade-by-id/show-trade-by-id.component';
import {SenatorAllCompanyMatching} from '../../../../../api/models/senator-all-company-matching';
import {SenatorAllCompanyMatchingMatchedRow} from '../../../../../api/models/senator-all-company-matching-matched-row';
import {SelectionModel} from '@angular/cdk/collections';
import UpdateAllCompanyMatchingRowParams = SenatorQualityGateService.UpdateAllCompanyMatchingRowParams;

@Component({
  selector: 'app-best-match-issuer-mapping-dialog',
  templateUrl: './best-match-issuer-mapping-dialog.component.html',
  styleUrls: ['./best-match-issuer-mapping-dialog.component.scss']
})
export class BestMatchIssuerMappingDialog implements OnInit, AfterViewInit {

  @ViewChild(ShowTradeByIdComponent)
  showTradeById: ShowTradeByIdComponent;

  showDialog = false;
  @Output() closeClicked = new EventEmitter();

  recordToFindMatchFor: SenatorAllCompanyMatching;

  selection = new SelectionModel<SenatorAllCompanyMatchingMatchedRow>(true, []);

  twoIQAssetsList: SenatorCompany[] = [];
  issuerIndex: number;

  // mat table vars
  displayedColumns: string[] = ['select', 'trade', 'matchScore', 'assetName', 'gvkey', 'assetType', 'transactionType', 'transactionDate'];
  issuerTableDataSource: MatTableDataSource<SenatorAllCompanyMatchingMatchedRow>;

  pageSize: number;
  pageNumber: number;
  pageSizeOptions: number[] = [10, 20, 50];
  pageEvent: PageEvent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  inputForm: FormGroup;
  isSearchingIssuerName: boolean;
  lastPageNumber: number;

  loadingData: boolean;
  assetNamesLoading: boolean;
  displayUpdateForm: boolean;


  constructor(private qualityGateService: SenatorQualityGateService,
              private _senatorService: SenatorService, private senatorService: SenatorService,
              public snackBar: MatSnackBar, private _fb: FormBuilder, private changeDetectorRefs: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.initVars();
    this.createInputForm();
  }

  ngAfterViewInit() {
    if (this.issuerTableDataSource) {
      this.issuerTableDataSource.paginator = this.paginator;
      this.issuerTableDataSource.sort = this.sort;
    }
  }

  initVars() {
    this.pageSize = 10;
    this.pageNumber = 1;
    this.assetNamesLoading = false;
    this.isSearchingIssuerName = false;
    this.lastPageNumber = 0;
    this.displayUpdateForm = false;

  }

  createInputForm() {
    this.inputForm = this._fb.group({
      'new2iqAssetName': [null, Validators.required],
      'gvkey': [null, Validators.required],
      'permid': []
    });
  }

  populateMatchings() {
    this.loadingData = true;
    if (this.recordToFindMatchFor !== null && this.recordToFindMatchFor !== undefined
            ) {
      const recordToFindMatchForTemp: SenatorAllCompanyMatchingMatchedRow = {
        matching_id: 0,
        trade_id: this.recordToFindMatchFor.trade_id,
        type: this.recordToFindMatchFor.type,
        similartName: this.recordToFindMatchFor.nameAssigned,
        gvkey: this.recordToFindMatchFor.gvkey,
        transactionDate: this.recordToFindMatchFor.transactionDate,
        transactionType: this.recordToFindMatchFor.transactionType,
        tradeIndex: this.recordToFindMatchFor.tradeIndex,
        assetType: this.recordToFindMatchFor.assetType,
        sourceUrl: this.recordToFindMatchFor.sourceUrl,
        howMatched: 'assigned',
        matchScore: 0.0
      };

      const data: Array<SenatorAllCompanyMatchingMatchedRow> = [];
      data.push(recordToFindMatchForTemp);
      this.recordToFindMatchFor.matchings.forEach( (element) => {
        data.push(element);
      });
      this.issuerTableDataSource = new MatTableDataSource<SenatorAllCompanyMatchingMatchedRow>(data);
      console.log('record matchings', this.recordToFindMatchFor.matchings);
      console.log('data:', data);
    } else {
      this.issuerTableDataSource = new MatTableDataSource<SenatorAllCompanyMatchingMatchedRow>();
    }
    this.selection.clear();
    this.loadingData = false;
  }

  onUpdateClick() {
    console.log('selections ', this.selection);
    console.log('status', this.selection.selected.length == 0);

    const newName = this.inputForm.get('new2iqAssetName').value;
    const newGvkey = this.inputForm.get('gvkey').value;
    const newPermid = this.inputForm.get('permid').value;
    console.log('new name', newName);
    console.log('new gvkey', newGvkey);
    console.log('new permid', newPermid);

    const params : UpdateAllCompanyMatchingRowParams = {
      senatorAllCompanyMatchingMatchedRow: this.selection.selected,
      newIssuerName: newName,
      newGvkey: newGvkey
    } as UpdateAllCompanyMatchingRowParams

    this.qualityGateService.updateAllCompanyMatchingRow(params).subscribe((res: any) => {
      console.log('save multiple res', res);
      this.selection.clear();
      this.inputForm.get('new2iqAssetName').setValue(null);
      this.inputForm.get('gvkey').setValue(null);
      this.inputForm.get('permid').setValue(null);
      this.openSnackBar('Issuer details has been updated successfully!', 'Close');
      this.close();

    }, (err) => {
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong! please enter a valid company name.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {

    });
  }


  searchAssetNames(companyName: string) {
    // this.activeRow = trade;
    this.assetNamesLoading = true;
    // console.log('Key up event', name);
    this._senatorService.getSenatorAssetNames(companyName).subscribe((res: SenatorCompany[]) => {
      this.twoIQAssetsList = res;
    }, (err) => {
      this.assetNamesLoading = false;
      // console.log('file update Error', err);
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong! please enter a valid company name.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {
      this.assetNamesLoading = false;
      if (this.twoIQAssetsList.length === 0) {

        this.snackBar.open('No Company found with this name', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      }
    });
  }

  mapCompanyWith2IQ(event, company: SenatorCompany) {
    if (event.source.selected) {
      this.inputForm.get('gvkey').setValue(company.gvkey);
    }
  }

  resetGvkey() {
    this.inputForm.get('gvkey').setValue(null);
  }

  assignZeroGvkey() {
    this.inputForm.get('gvkey').setValue('000000');
  }

  checkFormValidity() {
    return this.inputForm.invalid;
  }


  openSnackBar(message: string, action: string
  ) {
    this.snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }

  openTrade(trade_id: number, type: string) {
    this.showTradeById.loadDialog(trade_id, type == 'R' ? 'Representative' : 'Senator');
  }

  tradeClosedEvent() {
    this.populateMatchings();
  }

  loadDialog(recordToFindMatchFor: SenatorAllCompanyMatching) {
    this.recordToFindMatchFor = recordToFindMatchFor;
    console.log('recordToFindMatchFor ', this.recordToFindMatchFor);
    this.populateMatchings();
    this.showDialog = true;
  }

  public close() {
    this.showDialog = false;
    this.closeClicked.emit();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.issuerTableDataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.issuerTableDataSource.data.forEach(row => this.selection.select(row));
  }
}
